import { DATE_FORMAT } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

type Props = {
  checkIn: Date;
  checkOut: Date;
};

export const CheckInOut = ({ checkIn, checkOut }: Props) => {
  const { localeFormat, t } = useTranslation('global');
  const checkInDate = localeFormat(checkIn, DATE_FORMAT.MEDIUM);
  const checkOutDate = localeFormat(checkOut, DATE_FORMAT.MEDIUM);

  return (
    <div className="rounded-12 bg-background-secondary-default flex gap-8 p-16">
      <div className="flex flex-1 flex-col gap-4">
        <p className="body-m text-content-secondary-bg-primary">
          {t('travel.hotel.search.checkin')}
        </p>
        <p className="body-m text-content-primary">{checkInDate}</p>
      </div>
      <div className="border-border-default h-full w-px border-l" />
      <div className="flex flex-1 flex-col gap-4 text-right">
        <p className="body-m text-content-secondary-bg-primary">
          {t('travel.hotel.search.checkout')}
        </p>
        <p className="body-m text-content-primary">{checkOutDate}</p>
      </div>
    </div>
  );
};
